<template>
	<div>
		<ul class="navtree shadow-sm">
			<li style="background-color: rgba(0,0,0,0.15); border-bottom: 1px solid rgba(0,0,0,0.25); color: black; padding: 0.75rem 1rem; font-size: 120%">
				<strong>Project:</strong> {{projectName}}
			</li>
			<ul>
				<li class="narrow">
					<a :href="'#'+breadcrumb[2].path"><i class="fas fa-exchange-alt"></i>Switch Project</a>
				</li>
				<li class="narrow" :class="{ active : isMenuActive( '/' ) }">
					<a :href="'#'+breadcrumb[3].path"><i class="fas fa-tools"></i>Project Dashboard</a>
				</li>
			</ul>
		</ul>
		<ul class="navtree shadow-sm">
			<li :class="{ active : isMenuActive( '/collections' ) }" style="position: relative;">
				<a :href="urlToSection('/collections')"><i class="fas fa-boxes"></i>Collections</a>
				<select v-if="collectionGroups.length > 0" v-model="selectedCollectionGroup" class="form-control" style="width: 230px; position: absolute; right: 5px; top: 5px;">
					<option :value="undefined">- Show All -</option>
					<option v-for="group in collectionGroups" :key="group" :value="group">{{group}}</option>
				</select>
				<ul v-if="withinSection( currentSection, '/collections')">
					<li v-for="c in projectCollections" :key="c.$id" :class="{ active : isMenuActive( '/collections/'+getRawId(c.$id) ) }">
						<a :href="urlToSection('/collections/'+getRawId(c.$id))"><i class="fas fa-box"></i><i>{{c.title||getRawId(c.$id)}}</i></a>
						<ul v-if="withinSection( currentSection, '/collections/'+getRawId(c.$id) )">
							<li :class="{ active : isMenuActive( '/collections/'+getRawId(c.$id)+'/objects' ) }">
								<a :href="urlToSection('/collections/'+getRawId(c.$id))+'/objects'"><i class="fas fa-cubes"></i>Data Objects</a>
								<!-- <ul v-if="withinSection( currentSection, '/collections/'+getRawId(c.$id)+'/objects' )">
									<li v-for="(o,index) in collectionObjects" :key="o.$id" :class="{ active : isMenuActive( '/collections/'+getRawId(c.$id)+'/objects/'+o.$id ) }">
										<a :href="urlToSection('/collections/'+getRawId(c.$id)+'/objects/'+o.$id)"><i class="fas fa-cube"></i><em>{{o.title||o.name||o.$id}}</em></a>
									</li>
								</ul> -->
							</li>
						</ul>
					</li>
				</ul>
			</li>
		</ul>
		<ul class="navtree shadow-sm">
			<li :class="{ active : isMenuActive( '/apikeys' ) }">
				<a :href="urlToSection('/apikeys')"><i class="fas fa-lock-open"></i>API Keys</a>
				<ul v-if="withinSection( currentSection, '/apikeys' )">
					<li v-for="ak in projectApiKeys" :key="ak.$id" :class="{ active : isMenuActive( '/apikeys/'+getRawId(ak.$id) ) }">
						<a :href="urlToSection('/apikeys/'+getRawId(ak.$id))"><i class="fas fa-box"></i><i>{{ak.title||getRawId(ak.$id)}}</i></a>
					</li>
				</ul>
			</li>
		</ul>
		<ul class="navtree shadow-sm">
			<li :class="{ active : isMenuActive( '/schemas') }">
				<a :href="urlToSection('/schemas')"><i class="fas fa-shapes"></i>Schemas <em style="color:#D65F11;"></em></a>
				<ul v-if="withinSection( currentSection, '/schemas' )">
					<!-- <li v-for="(s,key) in projectSchemas" :key="s.id" :class="{ active : isMenuActive( '/schemas/'+getRawId(s.id) ) }">
						<a :href="urlToSection('/schemas/'+getRawId(s.id))"><i class="fas fa-box"></i><i>{{s.name||getRawId(s.id)}}</i></a>
					</li> -->
					<schema-tree-item v-for="s in projectSchemas" :model="s" :key="s.id"></schema-tree-item>
				</ul>
			</li>
		</ul>
		<ul class="navtree shadow-sm">
			<li :class="{ active : isMenuActive( '/statistics') }">
				<a style="cursor: not-allowed"><i class="fas fa-chart-bar"></i>Statistics <em style="color:#D65F11;">(soon)</em></a>
			</li>
		</ul>
		<ul class="navtree shadow-sm">
			<li :class="{ active : isMenuActive( '/validators') }">
				<a style="cursor: not-allowed"><i class="fas fa-check-double"></i>Validators <em style="color:#D65F11;">(soon)</em></a>
			</li>
		</ul>
		<ul class="navtree shadow-sm">
			<li :class="{ active : isMenuActive( '/mixins') }">
				<a style="cursor: not-allowed"><i class="fas fa-vials"></i>Mixins <em style="color:#D65F11;">(soon)</em></a>
			</li>
		</ul>
		<ul class="navtree shadow-sm">
			<li :class="{ active : isMenuActive( '/channels') }">
				<a style="cursor: not-allowed"><i class="fas fa-broadcast-tower"></i>Channels <em style="color:#D65F11;">(soon)</em></a>
			</li>
		</ul>
		<ul class="navtree shadow-sm">
			<li :class="{ active : isMenuActive( '/endpoints') }">
				<a style="cursor: not-allowed"><i class="fas fa-sitemap"></i>Endpoints <em style="color:#D65F11;">(soon)</em></a>
			</li>
		</ul>
	</div>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import SchemaTreeItem from "@/components/utilities/SchemaTreeItem";
import Vue from 'vue';

export default {
	name: "project-navigation",
	props: [ 'breadcrumb' ],
	data() {
		return {
			selectedCollectionGroup : undefined
		};
	},
	components: { SchemaTreeItem },
	created( )
	{
		if( this.projectCollections.length < 2 )
			this.listCollections( { nodeId : this.nodeId, projectId : this.projectId } );
	},
	computed:
	{
		projectId: function( ) {
			try {
				if( /^\/nodes\/[^\/]+\/projects\/[^\/]+$/.test( this.breadcrumb[3].path ) )
					return this.breadcrumb[3].name;
			} catch( err ) { }
			return null;
		},
		nodeId: function( ) {
			try {
				if( /^\/nodes\/[^\/]+$/.test( this.breadcrumb[1].path ) )
					return this.breadcrumb[1].name;
			} catch( err ) { }
			return null;
		},
		projectName: function( ) {
			try {
				let project = this.project( this.nodeId, this.projectId );
				return project.title || project.$id;
			} catch( err ) { }
			return null;
		},
		currentSection: function( ) {
			try {
				if( this.projectId )
				{
					let sectionPath = '/'+ this.breadcrumb[this.breadcrumb.length-1].path.split('/').slice(5).join('/');
					return sectionPath;
				}
			} catch( err ) { }
			return "";
		},
		collectionGroups: function( ) {
			const groups = {};
			const collections = this.collections( this.nodeId, this.projectId );
			for( const c of collections )
				if( c.group )
					groups[c.group] = true;
			return Object.keys( groups );
		},
		projectCollections: function( ) {
			try {
				const collections = this.collections( this.nodeId, this.projectId );
				if( !this.selectedCollectionGroup )
					return collections;
				return collections.filter( c => c.group == this.selectedCollectionGroup )
			} catch( err ) { return []; }
		},
		projectApiKeys: function( ) {
			try {
				return this.apiKeys( this.nodeId, this.projectId );
			} catch( err ) { return []; }
		},
		/**
		 *	{
		 * 		"<id>" : {
		 * 			name : "<name>",
		 * 			id : "<id>",
		 * 			active : true,		// isMenuActive( '/schemas')
		 * 			expanded : true,	// withinSection( currentSection, '/schemas' )
		 * 			url : "<url>",		// urlToSection('/schemas/'+getRawId(s.$id))
		 * 			children : {
		 * 				"<id>" : { ... }
		 * 			}
		 * 		}
		 * 	}
		 */
		projectSchemas: function( ) {
			try {
				const schemas = this.schemas( this.nodeId, this.projectId );
				const model = { };	// Hierarchical schema lookup. NO ARRAYS! .children is a lookup object.
				for( let i=0; i < schemas.length; i++ )
				{
					const s = schemas[i];
					const id = s.$id.substring( s.$id.indexOf( ":" ) + 1 );
					const parts = id.split( '.' );
					
					if( !parts[parts.length-1] )
						parts.pop( );	// Get rid of the last element, if empty.
					
					let thisId = "";
					let currentModel = model;
					for( let i=0; i < parts.length; i++ )
					{
						const name = parts[i];
						thisId += name +'.';
						if( !currentModel[name] )
							currentModel[name] = {
								name : name,
								id : thisId,
								active : ( '/schemas/'+ thisId == this.currentSection ),
								expanded : this.currentSection.startsWith( '/schemas/'+ thisId ),
								url : this.urlToSection('/schemas/'+ thisId ),
								children : { }
							};
						
						currentModel = currentModel[name].children;
					}
				}
				return model;
			} catch( err ) { return { }; }
		},
		collectionName: function( ) {
			try {
				if( /^\/nodes\/[^\/]+\/projects\/[^\/]+\/collections\/[^\/]+$/.test( this.breadcrumb[5].path ) )
					return this.breadcrumb[5].name;
			} catch( err ) { }
			return null;
		},
		// collectionObjects: function( ) {
		// 	try {
		// 		if( this.collectionName )
		// 			return this.objects( this.nodeId, this.projectId, this.collectionName ).slice(0,5);
		// 	} catch( err ) { }
		// 	return [];
		// },
		...mapGetters( "projects", {
			projects: "projects", // map STATE projects/all to "projects" AS A FUNCTION, which requires the nodeId as input!
			project: "project"	// function( nodeId, projectId )
		}),
		...mapGetters( "collections", {
			collections: "collections",
			collection: "collection"
		}),
		...mapGetters( "apiKeys", {
			apiKeys: "apiKeys",
			apiKey: "apiKey"
		}),
		// ...mapGetters( "objects", {
		// 	objects: "objects",
		// 	object: "object"
		// }),
		...mapGetters( "schemas", {
			schemas: "schemas",
			schema: "schema"
		}),
	},
	methods:
	{
		...mapActions({
			listCollections: "collections/list"
		}),
		isMenuActive: function( section, activeDepth = 0 )
		{
			//console.log( "CURRENT SECTION:", this.currentSection );
			if( !this.currentSection.startsWith( section ) )
				return false;
			let subPath = this.currentSection.substring( section.length );
			if( subPath == "" )
				return true;
			if( !subPath.startsWith( '/' ) )
				return false;
			let subParts = subPath.split( '/' );
			if( subParts[0] == '' )
				subParts.shift( );
			return subParts.length <= activeDepth;
		},
		// removes "<project-id>:" prefix, if exists.
		getRawId: function( id )
		{
			const parts = id.split( ':' );
			return ( parts.length > 1 ? parts[1] : id );
		},
		withinSection( mySection, matchSection )
		{
			return mySection == matchSection || mySection.startsWith( matchSection + "/" );
		},
		urlToSection: function( section )
		{
			try {
				if( !section.startsWith('/') )
					section = "/"+ section;
				if( /^\/nodes\/[^\/]+\/projects\/[^\/]+$/.test( this.breadcrumb[3].path ) )
					return "#"+ this.breadcrumb[3].path + section;
			} catch( err ) { }
			return section;
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/utilities/ProjectNavigation.vue